import React, {useCallback, useMemo, useState} from 'react';
import parse from 'html-react-parser';
import PopUp from 'js/components/Common/PopUp/PopUp';
import Button from 'js/components/Common/Button/Button';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import EmbedVideo from 'js/components/Common/EmbedVideo/EmbedVideo';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import {ProductType} from '../../Offerings';
import classes from './CourseInfo.module.pcss';
import {ImageBlockDataInterface} from 'js/components/Common/Image/ImageBlockDataInterface';


interface Props {
    courseTitle: string,
    activeCourseInfo: ProductType,
    linkText: string,
    linkButton: {
        link: string
    }
}

const CourseInfo = ({courseTitle, activeCourseInfo, linkButton, linkText}: Props) => {
    const [popUpTrigger, setPopUpTrigger] = useState<any>(false);
    const [videPreview, setVideoPreview] =
        useState<ImageBlockDataInterface>(null);
    const [videoLink, setVideoLink] = useState<string>('');
    const video = useMemo(() =>
        activeCourseInfo?.videoButton, [activeCourseInfo]);
    const isPopup = useMemo(() =>
            video?.videoLink &&
            video?.videoPreview?.mediaItemUrl,
        [video]);

    const eventData = useMemo(() => ({
        category: 'Training Page',
        courseName: courseTitle,
        productName: activeCourseInfo?.productName
    }), [activeCourseInfo, courseTitle]);

    const trailerButtonEventHandler = useCallback(async () => (
        await MixPanelWrapper.TrackEvent(
            'Trailer button is clicked on',
            eventData
            )
    ), [eventData]);

    const playButtonEventHandler = useCallback(async () => (
        await MixPanelWrapper.TrackEvent(
            '"Play" button is clicked on for video',
            eventData
        )
    ), [eventData]);

    const closeEventHandler = useCallback(async () => (
        await MixPanelWrapper.TrackEvent(
            'Close video player',
            eventData
        )
    ), [eventData]);

    return (
        <DataValidator data={activeCourseInfo}>
            <article className={classes.CourseInfo}>
                <div className={classes.ContentWrap}>
                    <div className={classes.CourseInfoSection}>
                        <strong>In this Training</strong>
                        <ul>
                            {activeCourseInfo?.inThisTraining?.map((item, index) =>
                                <li key={index}><span>{parse(item?.item || '')}</span></li>
                            )}
                        </ul>
                    </div>
                    <div className={classes.CourseInfoSection}>
                        <strong>About This Training</strong>
                        <p className={classes.CourseInfoDescription}>
                            {parse(activeCourseInfo?.aboutThisTraining || '')}
                        </p>
                    </div>
                </div>
                <div className={classes.ButtonsWrap}>
                    <Button
                        additionalStylesClass={classes.Button}
                        type={'button'}
                        text={parse(`<span>${activeCourseInfo?.videoButton?.buttonLabel || 'Trailer'}</span>`)}
                        disabled={!isPopup}
                        handler={async () => {
                            setVideoPreview(video?.videoPreview);
                            setVideoLink(video?.videoLink);
                            setPopUpTrigger(true);
                            await trailerButtonEventHandler();
                        }}
                        buttonType={'ButtonColored'} buttonColorType={'Pink'}/>
                    <Button type={linkButton?.link?.length ? 'a' : 'button'}
                            additionalStylesClass={classes.Button}
                            text={linkText || 'Guided Self Learning'}
                            disabled={!linkButton?.link?.length}
                            link={linkButton?.link}
                            buttonColorType={'Pink'}
                            buttonType={'ButtonUncolored'}/>
                    {isPopup && videoLink && videPreview ?
                        <PopUp
                            type={'S'}
                            additionalClass={classes.Popup}
                            popUpTrigger={popUpTrigger}
                            popUpClose={async () => {
                                setPopUpTrigger(false);
                                setVideoLink('');
                                setVideoPreview(null);
                                await closeEventHandler();
                            }}>
                            <EmbedVideo
                                title={activeCourseInfo?.productName}
                                customVideoSize={{
                                    width: '100%',
                                    height: '388'
                                }}
                                sendEventHandler={async () =>
                                    await playButtonEventHandler()}
                                link={videoLink}
                                preview={videPreview} />
                        </PopUp> : null}
                </div>
            </article>
        </DataValidator>
    );
};

export default CourseInfo;
